import React from 'react';
import Contact from '../Home/Contact/Contact';
import Footer from '../Home/Footer/Footer';
import Navbar from '../Home/Navbar/Navbar';

const ContactMe = () => {
    return (
        <>
           <Navbar />
           <Contact />
           <Footer /> 
        </>
    );
};

export default ContactMe;